var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.891,
    height: 30.829,
    viewBox: "0 0 37.891 30.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -44.698)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.698)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.995,54.041H32.358l-1.021-7.7a1.91,1.91,0,0,0-2.132-1.627L1.646,48.366A1.9,1.9,0,0,0,.389,49.1a1.877,1.877,0,0,0-.372,1.4L2.343,68.036a1.892,1.892,0,0,0,2.125,1.634l1.826-.241v4.2a1.9,1.9,0,0,0,1.9,1.9H35.995a1.9,1.9,0,0,0,1.9-1.9V55.937A1.9,1.9,0,0,0,35.995,54.041Zm-4.911,0H26.149L31,53.4ZM1.269,50.327a.619.619,0,0,1,.125-.463.632.632,0,0,1,.421-.246L29.37,45.966a.641.641,0,0,1,.715.543l.25,1.882L1.518,52.213ZM6.294,68.154l-1.988.262a.632.632,0,0,1-.71-.543h0L2.186,57.22l4.108-.543Zm.083-12.763-4.36.575-.332-2.5L30.5,49.645l.19,1.448.14,1.052-14.3,1.9H8.19A1.9,1.9,0,0,0,6.377,55.392ZM36.626,73.631a.632.632,0,0,1-.632.632H8.19a.632.632,0,0,1-.632-.632V55.956c0-.006,0-.013,0-.019a.632.632,0,0,1,.632-.632h27.8a.632.632,0,0,1,.632.632Z",
    transform: "translate(0 -44.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M292.528,216.681a3.161,3.161,0,0,0,.666-.666,3.16,3.16,0,1,0,0-3.752,3.16,3.16,0,1,0-.666,4.419Zm3.194-4.438a1.9,1.9,0,1,1-1.9,1.9A1.9,1.9,0,0,1,295.722,212.243Zm-5.055,0a1.9,1.9,0,1,1-1.9,1.9A1.9,1.9,0,0,1,290.666,212.243Z",
    transform: "translate(-264.782 -197.844)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.264,
    height: 1.264,
    transform: "translate(10.086 13.767)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.583,
    height: 1.264,
    transform: "translate(12.613 13.767)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.111,
    height: 1.264,
    transform: "translate(10.086 16.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M151.061,322.981h-22.75a.632.632,0,0,0-.632.632V327.4a.632.632,0,0,0,.632.632h22.75a.632.632,0,0,0,.632-.632v-3.792A.632.632,0,0,0,151.061,322.981Zm-.632,3.792H128.943v-2.528h21.486Z",
    transform: "translate(-117.593 -300.999)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/media/icon-credit-card.cba8c962b85ee718d1ecf008ecd933af.svg";
export { ForwardRef as ReactComponent };